export default "__VITE_ASSET__Bx0ek2yx__"